import PropTypes from "prop-types";
import { Modal, ModalBody } from "reactstrap";
import CLoseImg from "../../../../assets/images/closeIconModal.svg";
import bykea from "../../../../assets/images/riderprof.png";
import tcsLogo from "../../../../assets/images/tcslogo.jpg";
import DhlLogo from "../../../../assets/images/DHLIcon.png";
import dotimg from "../../../../assets/images/orderRec.png";
import { useEffect, useState } from "react";
import ErrorModal from "Components/Common/ErrorModal";
import PostEx from "../../../../assets/images/postEx.png";

interface FindModalProps {
    show: boolean;
    onCloseClick: () => void;
    activities: any,
    order: any
}

const TrackOrderMOdal: React.FC<FindModalProps> = ({ show, onCloseClick, activities, order }) => {
    const [showModal, setShowModal] = useState({
        isVisible: false,
        color: false,
    });

    const [errorMessage, setErrorMessage] = useState<string>("");

    useEffect(() => {
        console.log(order)
    }, []);

    return (
        <>
            <ErrorModal
                show={showModal.isVisible}
                message={errorMessage}
                color={showModal.color}
                onCloseClick={() => setShowModal({ isVisible: false, color: false })}
            />
            <Modal isOpen={show} centered className="trackMOdal">
                <img
                    data-testing-id="closeIcon"
                    onClick={onCloseClick}
                    className='closeIconModal'
                    src={CLoseImg}
                    alt=""
                />
                <ModalBody className="modal_Body">
                    <div className="mainDv">
                        <div className="headerDV">
                            {order?.isQuickCommerce === true ? (
                                order?.trackingNumber || order?.assignRider?.buypassId ? (
                                    <div className="headnigRow">
                                    <h5>Tracking ID: <span className="text-dark">{typeof (order?.trackingNumber || order?.assignRider?.buypassId) === "string" || typeof (order?.trackingNumber || order?.assignRider?.buypassId) === "number" ? (order?.trackingNumber || order?.assignRider?.buypassId) : "-"}</span></h5>
                                    <i
                                        onClick={(event) => {
                                            event.stopPropagation();
                                            navigator.clipboard.writeText(order?.trackingNumber || order?.assignRider?.buypassId);
                                            setShowModal({ isVisible: true, color: true });
                                            setErrorMessage("Tracking Id Copied");
                                            setTimeout(() => {
                                                setShowModal({
                                                    isVisible: false,
                                                    color: false,
                                                });
                                            }, 1000);
                                        }}
                                        className='bx bx-copy text-secondary fw-bold ms-1 fs-6 cursor-pointer'></i>
                                </div>
                                ) : null
                                
                            ) : (
                                order?.eCommerceShipment?.consignmentNo ? (
                                     <div className="headnigRow">
                                    <h5>Tracking ID: <span className="text-dark">{typeof order?.eCommerceShipment?.consignmentNo === "string" || typeof order?.eCommerceShipment?.consignmentNo === "number" ? order?.eCommerceShipment?.consignmentNo : "-"}</span></h5>
                                    <i
                                        onClick={(event) => {
                                            event.stopPropagation();
                                            navigator.clipboard.writeText(order?.eCommerceShipment?.consignmentNo);
                                            setShowModal({ isVisible: true, color: true });
                                            setErrorMessage("Tracking Id Copied");
                                            setTimeout(() => {
                                                setShowModal({
                                                    isVisible: false,
                                                    color: false,
                                                });
                                            }, 1000);
                                        }}
                                        className='bx bx-copy text-secondary fw-bold ms-1 fs-6 cursor-pointer'></i>
                                </div>
                                ) : null
                            )}
                            <div className="byKaDV">
                                <img src={
                                        order?.logisticPartner?.title === "TCS"
                                        ? tcsLogo
                                        : order?.logisticPartner?.title === "DHL"
                                        ? DhlLogo : order?.logisticPartner?.title === "PostEx" ? PostEx
                                        : order?.assignRider?.profilePicture?.url || bykea
                                        } alt="Bykea" />
                                <div className="content">
                                    {/* <h5>Logistic Partner</h5> */}
                                    <h6>{order?.logisticPartner?.title || "Buypass Rider"}</h6>
                                </div>
                            </div>
                            <h4>Status</h4>
                        </div>
                        <div className="border"></div>
                        <div className="bodyDV">
                            {activities?.orders?.map((activity: any, index: number) => (
                                <div className="bodyItemDV">
                                    <div className="dataDv">
                                        <h4 className="mb-1">
                                            {new Date(activity?.createdOn).toLocaleDateString("en-US", { month: "short", day: "2-digit" }).replace(" ", ".")}
                                        </h4>
                                        <p>{new Date(activity?.createdOn).toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", hour12: true })}</p>
                                    </div>
                                    {index === 0 ? (
                                        <div className="proBar">
                                            <div> <img src={dotimg} alt="" style={{ height: "16px", width: "16px" }} /></div>
                                            <div className={"bar blue-bg"}></div>
                                        </div>
                                    ) : (
                                        <div className="proBar">
                                            <div className={"dot blue-bg"}></div>
                                            <div className={"bar blue-bg"}></div>
                                        </div>
                                    )}



                                    <div className="orderDv">
                                        <h4 className="mb-1">{activity?.sellerTitle}</h4>
                                        <h6>{activity?.sellerDescription}</h6>
                                    </div>
                                </div>
                            ))}
                            {Array.isArray(activities) && activities.length > 0 && (
                                <div className="bodyDV">
                                    {activities.map((activity: any, index: number) => (
                                        <div className="bodyItemDV" key={activity?._id || index}>
                                            <div className="dataDv">
                                                <h4 className="mb-1">
                                                    {activity?.createdOn ? new Date(activity?.createdOn).toLocaleDateString("en-US", { month: "short", day: "2-digit" }).replace(" ", ".") : "-"}
                                                </h4>
                                                <p>{activity?.createdOn ? new Date(activity?.createdOn).toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", hour12: true }) : "-"}</p>
                                            </div>
                                            <div className="proBar">
                                                <div className="dot"
                                                    style={{ background: activity?.isRefund === true || activity?.isReturn === true ? "red" : "#0877FF" }}
                                                ></div>
                                                {index !== activities.length - 1 && (
                                                    <div
                                                        className="bar"
                                                        style={{ background: activity?.isRefund === true || activity?.isReturn === true ? "red" : "#0877FF" }}
                                                    ></div>
                            
                                                )}
                                            </div>
                            
                                            <div className="orderDv">
                                                <h4 className="mb-1">{typeof activity?.sellerTitle === "string" || typeof activity?.sellerTitle === "number" ? activity?.sellerTitle : "-"}</h4>
                                                <h6>{typeof activity?.sellerDescription === "string" || typeof activity?.sellerDescription === "number" ? activity?.sellerDescription : "-"}</h6>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        </>
    );
};

TrackOrderMOdal.propTypes = {
    show: PropTypes.bool.isRequired,
    onCloseClick: PropTypes.func.isRequired,
    activities: PropTypes.any,
    order: PropTypes.any
};

export default TrackOrderMOdal;
